/* eslint-disable react/prop-types */
import { Navigate, Outlet } from 'react-router-dom'
import { withRouter } from '../../../withRouter'
import { TabBar } from '../../../components/generic'
import { FC } from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import { RotaPaywallScreen } from './RotaPaywallScreen'

type NavItem = {
  url: string
  label: string
}

const RotaRouteScreen: FC<{ location: any; router: any }> = ({
  location,
  router,
}) => {
  const flags = useFeatureFlags({
    flagNames: ['rostering_dev_features'],
  })?.data

  const { hasRota } = useHomeType()

  const flagsRosteringDevFeaturesEnabled =
    flags?.rostering_dev_features?.enabled

  let items: NavItem[] = []

  if (!hasRota) {
    items = []
  } else if (flagsRosteringDevFeaturesEnabled) {
    items = NAV_TABS_WITHOUT_PUBLISHED
  } else {
    items = NAV_TABS_WITH_MONITORING
  }

  return (
    <div>
      <TabBar
        // @ts-ignore
        items={items}
        resourceUrl="rota"
        location={location}
      />
      <Outlet />
      {hasRota ? (
        router.location.pathname === '/rota' && <Navigate to="builder" />
      ) : (
        <RotaPaywallScreen />
      )}
    </div>
  )
}

export default withRouter(RotaRouteScreen)

const NAV_TABS_WITH_MONITORING = [
  {
    url: 'monitoring',
    label: 'Monitoring',
  },
  // { there's something wrong with these checks. needs clean up
  //   url: 'published',
  //   label: 'Published Rota',
  // },
  {
    url: 'builder',
    label: 'Rota Builder',
  },
  {
    url: 'patterns',
    label: 'Manage Patterns',
  },
]

const NAV_TABS_WITHOUT_PUBLISHED = [
  {
    url: 'monitoring',
    label: 'Monitoring',
  },
  {
    url: 'builder',
    label: 'Rota Builder',
  },
  {
    url: 'patterns',
    label: 'Manage Patterns',
  },
]
